import { render, staticRenderFns } from "./systemNotifyEdit.vue?vue&type=template&id=5d4d32b8&"
import script from "./systemNotifyEdit.vue?vue&type=script&lang=js&"
export * from "./systemNotifyEdit.vue?vue&type=script&lang=js&"
import style0 from "./systemNotifyEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports